import * as React from 'react'
import { isBoolean } from 'lodash'
import { IDispatcher } from "../extensions/Dispatcher";

interface NoteProps{
    content?: string,
    dispatcher: IDispatcher
}

export default function (props:NoteProps){
        var str_content = props.content
        var regex1 = /\$percent\(([a-zA-Z0-9]*)\,([a-zA-Z0-9]*)\,([a-zA-Z0-9]*)\)/
        var match1 = str_content.match(regex1)
        if(match1 && match1.length == 4){
            let val1 = parseFloat(props.dispatcher.pullValue(match1[1]))
            let val2 = parseFloat(props.dispatcher.pullValue(match1[2]))
            let def = match1[3]
            if(val1 && !isNaN(val1) && val2 && !isNaN(val2)){
                let value = Math.round(val1 / val2 * 100)
                str_content = str_content.replace(regex1, value.toString())
            }else{
                if(def){
                    str_content = str_content.replace(regex1, def.toString())
                }else{
                    str_content = str_content.replace(regex1, '')
                }
            }
        }
        return (
            <div className="alert alert-info alert-dismissable" >
                {str_content}
            </div>
        )
} 